import { reportAnIssue } from '@libs/api/issues';
import { MemoryLogStorage } from '@libs/logger';
import { SystemUser } from '@libs/models/common';
import { OrganizationDetails } from '@libs/models/settings';
import { create } from 'zustand';

type InitialState = {
  open: boolean;
  submitting: boolean;

  sendIssueReport: (userData: SystemUser, orgDetails: OrganizationDetails, issueDescription: string) => Promise<void>;

  openDialog: () => void;
  closeDialog: () => void;
};

export const useReportIssueStore = create<InitialState>()((set) => ({
  open: false,
  submitting: false,

  sendIssueReport: async (userData, orgDetails, issueDescription) => {
    set({ submitting: true });
    try {
      const bufferContent = MemoryLogStorage.getInstance().serializeBuffer();
      const issueReportFileContent = `
App: AX
Organization: ${orgDetails.name} (${orgDetails.id}) ${orgDetails.website} Phone:${orgDetails.agency_phone_number} Address:${orgDetails.state}, ${orgDetails.city} ${orgDetails.address1}
User: ${userData.firstName} ${userData.lastName}(${userData.email}) #${userData.id}

Description: ${issueDescription}

Logs:
${bufferContent}`;
      const originalFile = new File(
        [issueReportFileContent],
        `FX-issue-report-${userData.email}-${new Date().toISOString()}.txt`,
        {
          type: 'text/plain',
        },
      );

      const compressionStream = new CompressionStream('gzip');
      const compressedStream = originalFile.stream().pipeThrough(compressionStream);
      const compressedArrayBuffer = await new Response(compressedStream).arrayBuffer();
      const compressedFile = new File(
        [compressedArrayBuffer],
        `FX-issue-report-${userData.email}-${new Date().toISOString()}.txt.gz`,
        {
          type: 'application/gzip',
        },
      );

      console.log(
        'Sending issue report with compressed file:',
        compressedFile,
        'Size:',
        (compressedFile.size / (1024 * 1024)).toFixed(2),
        'MB',
      );
      await reportAnIssue(issueDescription, [compressedFile]);
    } catch (error) {
      console.error('Failed to send issue report:', error);
      throw error;
    } finally {
      set({ submitting: false });
    }
  },

  openDialog: () => set({ open: true }),
  closeDialog: () => set({ open: false }),
}));
